import * as React from 'react';
import styled from "styled-components";
import { Toast } from '../store/types';
import ToastWidget from './ToastWidget';

const Container = styled.div`
  position: absolute;
  left: 0px;
  width: 100%;
  z-index: 900;
`;


interface Props {
  toasts: Toast[];
  closeHandler: (toastId: string) => void;
}


export function ToastBoard(props: Props) {
  const { toasts, closeHandler } = props;

  return (
    <Container>
      {toasts.map(toast => {
        const { id, title, message, type } = toast;

        return (
          <ToastWidget
            key={id}
            title={title}
            message={message}
            type={type}
          />
        );
      })}
    </Container>
  );
}
